import { TextField, InputAdornment } from "@mui/material";
import Slider from "@mui/material/Slider";
import { useState } from "react";

export const SliderComponent = ({
  range = { min: 0, max: 100 },
  values = { min: 0, max: 90 },
  handleChange = () => {},
}) => {
  const [fieldVals, setFieldVals] = useState(values);

  const handleFieldBlur = (id, value) => {
    const numericValue = Number(value);
    if (!isNaN(numericValue)) {
      const updatedValues = { ...fieldVals, [id]: numericValue };
      setFieldVals(updatedValues);
      handleChange(updatedValues);
    }
  };

  const handleFieldChange = (e) => {
    if (e && e.target) {
      const { id, value } = e.target;
      const numericValue = value === "" ? "" : Number(value);
      if (!isNaN(numericValue) || value === "") {
        setFieldVals((prev) => ({ ...prev, [id]: numericValue }));
      }
    }
  };

  const handleSliderChange = (e, newValue) => {
    if (Array.isArray(newValue)) {
      const updatedValues = { min: newValue[0], max: newValue[1] };
      setFieldVals(updatedValues);
      handleChange(updatedValues);
    }
  };

  return (
    <div className="my-1 flex items-center w-full">
      <form className="text-sm w-full" onSubmit={(e) => e.preventDefault()}>
        <div className="flex justify-between w-full gap-2">
          <TextField
            id="min"
            label="Min"
            variant="outlined"
            value={fieldVals.min}
            type="number"
            onBlur={(e) => handleFieldBlur(e.target.id, e.target.value)}
            onChange={handleFieldChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" className="mt-0.5">
                  $
                </InputAdornment>
              ),
              classes: {
                input: "p-2",
              },
            }}
          />
          <TextField
            id="max"
            label="Max"
            variant="outlined"
            value={fieldVals.max}
            type="number"
            onBlur={(e) => handleFieldBlur(e.target.id, e.target.value)}
            onChange={handleFieldChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" className="mt-0.5">
                  $
                </InputAdornment>
              ),
              classes: {
                input: "p-2",
              },
            }}
          />
        </div>
        <Slider
          className="my-4"
          value={[fieldVals.min, fieldVals.max]}
          onChange={handleSliderChange}
          min={range.min}
          max={range.max}
          valueLabelDisplay="auto"
          disableSwap
        />
      </form>
    </div>
  );
};
